import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}

// 获取食堂、档口、餐线树
export function getcanteentree (data) {
	return request({
		url: '/api/v2/alloc/canteen/tenant/tree',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取食堂档口树
export function getCanteenStallTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/canteen/system/auth/stall/tree',
		method: 'post',
		data: obj
	})
}

// 餐线下发菜谱-下发菜谱
export function mealLineCaiDown (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/v1/menudishes/issue/part/recipe',
		method: 'post',
		data: obj
	})
}

// 餐线下发菜谱-获取设备
export function mealLineDown (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/machine/meal/list',
		method: 'post',
		data: obj
	})
}

// 订餐规则--食堂获取
export function getDingcanRole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/takeOutRule/getTakeOutRuleByCanteenId',
		method: 'get',
		params: obj
	})
}
// 订餐规则--新增更新
export function editDingcanRole (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/takeOutRule/takeOutRuleSaveOrPut',
		method: 'post',
		data: obj
	})
}
// 标签-获取标签信息
export function getLabel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/label/queryListBasicsLabel',
		method: 'get',
		params: obj
	})
}
// 标签-新增标签信息
export function addLabel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/label/createBasicsLabel',
		method: 'post',
		data: obj
	})
}
// 标签-更新标签信息
export function putLabel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/label/updateBasicsLabel',
		method: 'post',
		data: obj
	})
}
// 标签-删除标签
export function delLabel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics/label/removeBasicsLabel',
		method: 'post',
		data: obj
	})
}
// 新增食堂
export const addCanteen = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/add-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 新增档口
export const addShopstall = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/add-stall',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取所有食堂
export const getAllCanteen = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/list-all-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取食堂列表
export const getCanteenList = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/page-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取档口列表
export const getShopstallList = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/page-stall',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改食堂
export const editCanteen = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改档口
export const editShopstall = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-stall',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 删除食堂
export const delCanteen = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/remove-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 删除档口
export const delShopstall = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/remove-stall',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 新增区域
export const addArea = (data) => {
	return request({
		url: '/api/v2/alloc/area/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 区域列表
export const getArea = (data) => {
	return request({
		url: '/api/v2/alloc/area/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 删除区域
export const delArea = (data) => {
	return request({
		url: '/api/v2/alloc/area/remove',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改区域
export const editArea = (data) => {
	return request({
		url: '/api/v2/alloc/area/update',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 获取区域名称
export const getAreaName = (data) => {
	return request({
		url: '/api/v2/alloc/area/get-area-name',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 系统区域食堂树
export const getAreaTree = (data) => {
	return request({
		url: '/api/v2/alloc/area/system/tree',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 聚合查询单个食堂
export const getCanteenDetail = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/get-canteen-for-modify',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 聚合查询单个食堂
export const getShopstallDetail = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/get-stall-for-modify',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询编号
export const getCanteenNum = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/get-canteen-num',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 取餐点
export const getPlace = (data) => {
	return request({
		url: '/api/v2/alloc/food/place/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const addPlace = (data) => {
	return request({
		url: '/api/v2/alloc/food/place/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const delPlace = (data) => {
	return request({
		url: '/api/v2/alloc/food/place/remove',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const editPlace = (data) => {
	return request({
		url: '/api/v2/alloc/food/place/modify',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getAllPlace = (data) => {
	return request({
		url: '/api/v2/alloc/food/place/list-name',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询配送设置
export const getPeisongDetail = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/query-canteen-delivery',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询点餐设置
export const getDiancanDetail = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/query-canteen-order',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询支付设置
export const getZhifuDetail = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/query-canteen-pay',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改营业状态
export const changeCanteenType = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-business-state',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 品类
export const addKind = (data) => {
	return request({
		url: '/api/v2/alloc/kind/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getKind = (data) => {
	return request({
		url: '/api/v2/alloc/kind/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const editKind = (data) => {
	return request({
		url: '/api/v2/alloc/kind/modify',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const delKind = (data) => {
	return request({
		url: '/api/v2/alloc/kind/remove',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getAllKind = (data) => {
	return request({
		url: '/api/v2/alloc/kind/list-name',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 商户保存配送设置
export const saveDelivery = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/save-canteen-delivery',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 商户保存支付设置
export const savePay = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/save-canteen-pay',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 商家获取自助餐设置
export const getZizhucan = (data) => {
	return request({
		url: '/api/v2/device/metadata/query-buffet',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 商家保存自助餐设置
export const saveZizhucan = (data) => {
	return request({
		url: '/api/v2/device/metadata/save-buffet',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 商家获取自助餐设置
export const getChupinjiSet = (data) => {
	return request({
		url: '/api/v2/device/metadata/query-production',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 商家保存自助餐设置
export const saveChupinjiSet = (data) => {
	return request({
		url: '/api/v2/device/metadata/save-production',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改档口是否叫号
export const changeShopstallCallnum = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-stall-use-call-num',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改档口是否报餐
export const changeShopstallIfbook = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-stall-if-book',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改食堂是否报餐
export const changeCanteenIfbook = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-canteen-if-book',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改食堂是否开启预订餐
export const changeCanteenIfReserve = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-canteen-if-reserve',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 修改档口是否开启预订餐
export const changeShopstallIfReserve = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-stall-if-reserve',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 餐线
export const getMealline = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/page-meal-line',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const addMealline = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/add-meal-line',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const editMealline = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/modify-meal-line',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const delMealline = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/remove-meal-line',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 餐桌
export const getDesk = (data) => {
	return request({
		url: '/api/v2/alloc/table/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const addDesk = (data) => {
	return request({
		url: '/api/v2/alloc/table/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const editDesk = (data) => {
	return request({
		url: '/api/v2/alloc/table/update',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const delDesk = (data) => {
	return request({
		url: '/api/v2/alloc/table/remove',
		method: 'post',
		data: { ...dataObj, content: data.tableId || undefined }
	})
}
export const getDeskDetail = (data) => {
	return request({
		url: '/api/v2/alloc/table/get-by-table-id',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 包间
export const getRoom = (data) => {
	return request({
		url: '/api/v2/alloc/room/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const addRoom = (data) => {
	return request({
		url: '/api/v2/alloc/room/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const editRoom = (data) => {
	return request({
		url: '/api/v2/alloc/room/update',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const delRoom = (data) => {
	return request({
		url: '/api/v2/alloc/room/remove',
		method: 'post',
		data: { ...dataObj, content: data.roomId || undefined }
	})
}
export const getRoomDetail = (data) => {
	return request({
		url: '/api/v2/alloc/room/get-by-room-id',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const changeRoomState = (data) => {
	return request({
		url: '/api/v2/alloc/room/modify-state',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getLineDetail = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/get-meal-line-for-modify',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getAreaCanteenStallTreeApi = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/tenant/tree',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量下载餐桌二维码
export const batchDownloadQrcode = data => {
	return request({
		url: '/api/v2/alloc/table/batch-download-qrcode',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
export const getAreaCanteenStallTree = (data) => {
	return request({
		url: '/api/v2/alloc/canteen/area-canteen-stall-tree',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
